import { topicEntries } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";

export default function TopicsSection() {
  return (
    <section id="topics" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
        <Reveal>
          <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
            <div>
              <span className="text-xs text-primary-600">按事件聚合 · 一键订阅</span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                追踪专题
              </h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600">
              把同一事件的进展、证据与通报收进一个专题，订阅后新线索会自动归档整理。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-6">
          {topicEntries.map((topic, index) => (
            <Reveal key={topic.name} delay={index * 80}>
              <a
                href="#topics"
                className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${topic.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {topic.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {topic.desc}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
                  <span>已收录 {topic.count}</span>
                  <span className="flex items-center gap-1 text-primary-600">
                    进入专题
                    <i className="ri-arrow-right-s-line" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}